module.exports = __webpack_public_path__ + "static/img/3tgimg.ac3d2a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/3tgimg.jpg
// module id = 56pH
// module chunks = 2